import * as React from 'react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getFuelLog, getVehicles } from '../../services/server-api';
import { CommandBar, Panel, List as FluentList, Text } from '@fluentui/react';
import { commandBarStyles } from '../styles';
import { useBoolean } from '@fluentui/react-hooks';
import { LogFuelForm } from './log-fuel-form';
import { FuelLogCard } from './fuel-log-card';
import { PaymentForm } from '../payments/payment-form';
import { Dropdown } from '../../common/dropdown';
export var FuelHistory = function () {
    var _a = useState(), fuelLog = _a[0], setFuelLog = _a[1];
    var _b = useState(), vehicleId = _b[0], setVehicleId = _b[1];
    var reloadData = useCallback(function () {
        getFuelLog(vehicleId).then(setFuelLog);
    }, [setFuelLog, vehicleId]);
    var _c = useState(), vehicles = _c[0], setVehicles = _c[1];
    useEffect(function () {
        getVehicles().then(setVehicles);
    }, []);
    useEffect(function () {
        if (vehicleId)
            reloadData();
    }, [reloadData, vehicleId]);
    var _d = useBoolean(false), addFuelLog = _d[0], _e = _d[1], showAddFuelLog = _e.setTrue, hideAddFuelLog = _e.setFalse;
    var _f = useState(null), selectedPayment = _f[0], setSelectedPayment = _f[1];
    var hideEditPayment = function () { return setSelectedPayment(null); };
    var commands = useCommandBarCommands(showAddFuelLog, reloadData);
    return (React.createElement(React.Fragment, null,
        React.createElement(CommandBar, { items: commands, styles: commandBarStyles }),
        React.createElement(Dropdown, { items: vehicles, onChange: setVehicleId, label: "Vehicle", value: vehicleId }),
        fuelLog && React.createElement(FluentList, { items: fuelLog.fuelLog, onRenderCell: function (f) {
                return React.createElement(Text, null,
                    React.createElement(FuelLogCard, { fuelLog: f, onViewPayment: function () { return setSelectedPayment(f.paymentId); } }));
            } }),
        React.createElement(Panel, { isOpen: addFuelLog, headerText: "Log Fuel", onDismiss: hideAddFuelLog },
            React.createElement(LogFuelForm, { onClose: hideAddFuelLog, onSave: reloadData })),
        React.createElement(Panel, { isOpen: !!selectedPayment, headerText: "Edit Payment", onDismiss: hideEditPayment },
            React.createElement(PaymentForm, { onClose: hideEditPayment, id: selectedPayment }))));
};
function useCommandBarCommands(onAddFuelLog, reloadData) {
    var commands = useMemo(function () { return ([
        {
            split: true,
            key: 'addFuelLog',
            text: 'Log Fuel',
            iconProps: { iconName: 'Add' },
            onClick: onAddFuelLog,
        },
        {
            key: 'refresh',
            text: 'Refresh',
            iconProps: { iconName: 'Refresh' },
            onClick: reloadData
        }
    ]); }, [reloadData, onAddFuelLog]);
    return commands;
}
